import React, { useId, useState, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import { StyledToggleButton } from "./ProxiesAccordion.styles";

type Props = {
    children: ReactElement;
};

const STORAGE_SHOULD_SHOW_PROXIES = "shouldShowProxies";

const Accordion = ({ children }: Props) => {
    const [shouldShowChildren, setShouldShowChildren] = useState<boolean>(
        localStorage.getItem(STORAGE_SHOULD_SHOW_PROXIES) !== null
            ? "true" === localStorage.getItem(STORAGE_SHOULD_SHOW_PROXIES)
            : true,
    );
    const panelId = useId();

    const { t } = useTranslation();

    const handleAccordionToggle = () => {
        setShouldShowChildren(!shouldShowChildren);
        localStorage.setItem(
            STORAGE_SHOULD_SHOW_PROXIES,
            (!shouldShowChildren).toString(),
        );
    };

    return (
        <div>
            <div>
                <StyledToggleButton
                    type="button"
                    onClick={handleAccordionToggle}
                    aria-expanded={shouldShowChildren}
                    aria-controls={panelId}
                >
                    {shouldShowChildren ? (
                        <ArrowUpwardIcon aria-hidden="true" />
                    ) : (
                        <ArrowDownwardIcon aria-hidden="true" />
                    )}
                    {t(shouldShowChildren ? "hideProxies" : "showProxies")}
                </StyledToggleButton>

                <div id={panelId} hidden={!shouldShowChildren}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
